"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorRampIndexes = exports.BAR_CHART_COLORS = void 0;
var style_1 = require("../../../../style");
exports.BAR_CHART_COLORS = [
    style_1.DesignSystemColor.Blue.DARK_3,
    style_1.DesignSystemColor.Blue.DARK_1,
    style_1.DesignSystemColor.Blue.LIGHT_1,
    style_1.DesignSystemColor.Blue.DARK_2,
    style_1.DesignSystemColor.Teal.DEFAULT,
    style_1.DesignSystemColor.Teal.LIGHT_2,
    style_1.DesignSystemColor.Teal.LIGHT_4,
    style_1.DesignSystemColor.Green.LIGHT_2,
    style_1.DesignSystemColor.Green.DEFAULT,
    style_1.DesignSystemColor.Green.DARK_1,
];
var getColorRampIndexes = function (requiredNumberOfColors) {
    if (requiredNumberOfColors === void 0) { requiredNumberOfColors = 1; }
    var sequentialColorIndexes = [
        /* 0 */ [],
        /* 1 */ [5],
        /* 2 */ [2, 8],
        /* 3 */ [1, 5, 9],
        /* 4 */ [1, 4, 6, 9],
        /* 5 */ [1, 3, 5, 7, 9],
        /* 6 */ [0, 2, 4, 5, 7, 9],
        /* 7 */ [0, 1, 3, 4, 6, 7, 9],
        /* 8 */ [0, 1, 3, 4, 5, 6, 7, 9],
        /* 9 */ [1, 2, 3, 4, 5, 6, 7, 8, 9],
        /* 10 */ [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    ];
    return sequentialColorIndexes[requiredNumberOfColors];
};
exports.getColorRampIndexes = getColorRampIndexes;
